import React from "react";
import { Link } from "react-router-dom";

const AccessDeniedLayer = () => {
  return (
    <div className='custom-bg'>
      <div className='container container--xl'>
        <div className='d-flex align-items-center justify-content-between py-24'>
          <Link to='/' className=''>
            <img src='assets/imgs/logo.png' alt='' />
          </Link>
          <Link to='/' className='btn btn-outline-primary-600 text-sm'>
            {" "}
            Go To Home{" "}
          </Link>
          {/* wesley  */}
        </div>
        {/* <div class="text-center py-res-120"> */}
        <div className='text-center pb-40 pt-48'>
          {/* <div className='max-w-500-px mx-auto'>
            <img src='assets/images/forbidden/forbidden-img.png' alt='' />
          </div> */}
          <div className='max-w-700-px mt-40 mx-auto'>
            <h3 className='max-w-1000-px mb-24'>Access Denied</h3>
            <p className='text-lg text-neutral-500 max-w-700-px'>
              You don't have authorization to get to this page. If it's not too
              much trouble, contact your site executive to demand access.
            </p>
            <Link
              to='/'
              className='d-inline-flex flex-shrink-0 btn btn-primary-600 align-items-center justify-content-center gap-8 mt-28 px-32 py-16'
            >
              <i className='ri-home-4-line' /> Go Back To Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedLayer;
